import InvestorIntro from './InvestorIntro'

export default InvestorIntro
